import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const HelpIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g>
                <g>
                    <path fill="currentColor" d="M12,22.25C6.348,22.25,1.75,17.652,1.75,12S6.348,1.75,12,1.75S22.25,6.348,22.25,12S17.652,22.25,12,22.25z M12,3.25c-4.825,0-8.75,3.925-8.75,8.75s3.925,8.75,8.75,8.75s8.75-3.925,8.75-8.75S16.825,3.25,12,3.25z"/>
                </g>
                <g>
                    <g>
                        <path fill="currentColor" d="M12.798,13.789c0.002,0.197-0.029,0.38-0.798,0.38c-0.843,0-0.906-0.217-0.919-0.406c-0.011-0.157-0.01-0.317-0.01-0.374c0-0.584,0.109-0.928,0.29-1.305c0.182-0.377,0.546-0.801,1.091-1.272s0.872-0.78,0.978-0.926c0.164-0.231,0.246-0.485,0.246-0.763c0-0.386-0.145-0.717-0.435-0.993c-0.291-0.276-0.683-0.414-1.175-0.414c-0.474,0-0.872,0.144-1.191,0.431c-0.24,0.215-0.423,0.516-0.55,0.901c-0.077,0.232-0.29,0.39-0.532,0.358L9.001,9.302c-0.304-0.04-0.49-0.339-0.42-0.637c0.141-0.601,0.452-1.126,0.934-1.578c0.627-0.589,1.452-0.884,2.471-0.884c1.073,0,1.928,0.298,2.562,0.894S15.5,8.388,15.5,9.179c0,0.438-0.116,0.853-0.35,1.244c-0.232,0.391-0.73,0.923-1.493,1.597c-0.394,0.349-0.64,0.629-0.735,0.841C12.826,13.074,12.794,13.242,12.798,13.789z M11,16L11,16c0-0.552,0.448-1,1-1h0c0.552,0,1,0.448,1,1v0c0,0.552-0.448,1-1,1h0C11.448,17,11,16.552,11,16z"/>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
